import script from "./StudentRevision.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRevision.vue?vue&type=script&setup=true&lang=js"

import "./StudentRevision.vue?vue&type=style&index=0&id=d23bcc40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d23bcc40"]])

export default __exports__